import React, { Component } from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import ReactPlayer from 'react-player'

import Waypoint from 'react-waypoint';
import styled from "react-emotion";

const Revealable = styled("div")`
  opacity: ${({ show }) => (show ? "100" : "0")};
  margin-top: ${({ show }) => (show ? "0" : "100px")};
  transition: opacity ease-out 0.5s, margin-top cubic-bezier(0, 0, 0.58, 1) 1s;`;

class Reveal extends Component {
  state = {
    revealed: false
  };
  reveal = () => {
    this.setState({ revealed: true });
  };
  render() {
    return (
      <Waypoint onEnter={this.reveal}>
        <Revealable show={this.state.revealed}>
          {this.props.children}
        </Revealable>
      </Waypoint>
    );
  }
}

const SlidingUp = styled("div")`
  opacity: ${({ show }) => (show ? "100" : "0")};
  transform: ${({ show }) => (show ? "translate(0,100px)" : "translate(0,0)")};
  transition: opacity ease-out 0.5s, transform cubic-bezier(0, 0, 0.58, 1) 1s;`;

class SlideUp extends Component {
  state = {
    revealed: false
  };
  reveal = () => {
    this.setState({ revealed: true });
  };
  render() {
    return (
      <Waypoint onEnter={this.reveal}>
        <SlidingUp show={this.state.revealed}>
          {this.props.children}
        </SlidingUp>
      </Waypoint>
    );
  }
}

const HeavenlyPatiencePage = () => (
    <section>
    <Helmet title="Celebrating Mastery" />
                  <div className="mastery-nav">
                    <Link to="/celebrating-mastery" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_passion.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">PASSION</span></span></Link>
                    <Link to="/celebrating-mastery/devilish-tenacity" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_tenacity.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">TENACITY</span></span></Link>
                    <Link to="/celebrating-mastery/heavenly-pioneering" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_pioneering.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">PIONEERING</span></span></Link>
                    <Link to="/celebrating-mastery/heavenly-patience" className="mastery-nav-link allegre active"><img className="img-responsive" src={require('../../images/_stories/illustration_patience.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">PATIENCE</span></span></Link> 
                    <Link to="/celebrating-mastery/heavenly-ritual" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_ritual.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">RITUAL</span></span></Link>
                    <Link to="/celebrating-mastery/devilish-details" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_details.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">DETAILS</span></span></Link>  
                  </div>
          {/*PATIENCE*/}
          <div className="mastery-block">
              <div className="mastery-block-header">
                <div className="grid-xl container">
                  <div className="columns">
                    <div className="column col-4 col-sm-12"><img className="img-responsive" src={require('../../images/_stories/illustration_patience.png')} /></div>
                    <div className="column col-6 col-sm-12">
                      <h1 className="allegre">HEAVENLY <span className="red">PATIENCE</span></h1>
                      <h4>天は、1日にしてならず</h4>
                       <p>ゴールデン・エールの最高峰と呼ばれるデュベルは、時に丁寧すぎるほど慎重な醸造工程を経て、2次発酵のための高温保存、さらに完成度を高めるための低温保存のあと送り出される。1本にかける実に90日を超える醸造過程は、すべてあなたに天国のようなおいしさを届けるため。それは苦難の道ではない、幸せへと続く道だ。</p>
                    </div>
                  </div>
                </div>
            </div>
            <div className="mastery-block-body relative">
               <img className="mastery-big-d" src={require('../../images/D_logo.png')} />
            <div className="grid-xl container">
                  <div className="columns">
                      <div className="column col-6 col-md-12">
                      <div className="mastery-block-text"><h4 className="red">デュベルは長時間寝かせて醸造される。<br />そばを通る時は…どうかお静かに。</h4>
                      <p>デュベル・モルトガット醸造所は、アントワープとブリュッセルをつなぐブレーンドンクの高速道路沿いにある。出来上がった商品を出荷するのにこれ以上便利な場所はないが、醸造室で眠るデュベルにとっては、少々やかましすぎるかもしれない。醸造所の壁に描かれた「Ssst...（シーっ）」の文字は、通過するドライバーたちに、デュベルがそこで静かに眠っていることを伝えている。悪魔が途中で起きないように、醸造所前の運転はどうかお静かに。</p>
                      </div>
                      <div className="video-wrapper">
        <ReactPlayer 
          className='react-player'
          url='https://www.youtube.com/watch?v=orPP6ipHYys'
          width='90%'
          height='90%'
        />
      </div>
                      </div>
                      <div className="column col-6 col-md-12">
                        <img className="img-responsive img-90" src={require('../../images/_stories/_patience/patience_sign.jpg')} />
                      </div>
                    <div className="mastery-block-img-footer">                                                     
                    <img className="img-responsive" src={require('../../images/_stories/illustration_patience.png')} />
                  </div></div>
             </div>
            </div>
        </div>
    </section>
  
)

export default HeavenlyPatiencePage



// WEBPACK FOOTER //
// ./src/pages/celebrating-mastery/heavenly-patience.js